import { render, staticRenderFns } from "./EditRectDefault.vue?vue&type=template&id=58b4403e&scoped=true&"
import script from "./EditRectDefault.vue?vue&type=script&lang=js&"
export * from "./EditRectDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b4403e",
  null
  
)

export default component.exports